/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { AlertBanner, Button } from '@ui/components';

export const InfoAlertBannerExample = () => (
    <AlertBanner severity="info" message="Sync scheduled for tonight." />
);

export const WarningAlertBannerExample = () => (
    <AlertBanner
        severity="warning"
        message="Some placements are missing rightsholder data."
    />
);

export const ErrorAlertBannerExample = () => (
    <AlertBanner
        severity="error"
        message="Report generation failed. Try again."
    />
);

export const SuccessAlertBannerExample = () => (
    <AlertBanner severity="success" message="Campaign saved successfully." />
);

export const LongContentAlertBannerExample = () => (
    <AlertBanner
        severity="warning"
        message="Partial data"
        description="This view is showing partial data because some sources have not finished aggregating. Inline banners communicate persistent page or card feedback and do not own toast, snackbar, or global notification behavior."
    />
);

export const ActionAlertBannerExample = () => (
    <AlertBanner
        severity="error"
        message="Export failed"
        action={<Button variant="secondary">Retry</Button>}
    />
);
